<template>
    <component
        :is="href ? 'a' : 'span'"
        :href="href"
        class="def-link"
    >
        <slot />
    </component>
</template>

<script>
export default {
    name: 'DefLink',
    props: {
        href: {
            type: String,
        }
    },
}
</script>

<style lang="scss" scoped>
.def-link{
    text-decoration-line: underline;
    text-underline-position: under;
    transition: .2s linear color;
    cursor: pointer;
    text-underline-color: currentColor;
    color: var(--color-main);
    &:hover{
        color: var(--color-dark-grey);
    }
}
</style>